import { render, staticRenderFns } from "./_RepairDialgTip.vue?vue&type=template&id=72a04cf6&scoped=true"
import script from "./_RepairDialgTip.vue?vue&type=script&lang=ts"
export * from "./_RepairDialgTip.vue?vue&type=script&lang=ts"
import style0 from "./_RepairDialgTip.vue?vue&type=style&index=0&id=72a04cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a04cf6",
  null
  
)

export default component.exports